jQuery($ => {
    class Popover {
        constructor(element, args = {}) {
            this._ = element;
            this._element = $(element);
            this._controlledbyId = this._element.data('controlledby');
            this._controlledby = $(`#${this._controlledbyId}`);
            this._focusable = this._element.find(
                'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            this._args = $.extend({
                // Defaults
            }, args);

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            this.setupPopper();
            // this._element.on('blur', this.handleBlur);
            // this._element.find('*').on('blur', this.handleBlur);
            this._element.on('keydown', this.handleKeydown);
            $(window).on('click', this.handleWindowClick);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Popper
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupPopper = () => {
            const placement = this.getPlacement();
            const { skidding, distance } = this.getOffsetByPlacement(placement);

            const settings = {
                placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [skidding, distance],
                        }
                    },
                    {
                        name: 'onUpdate',
                        enabled: true,
                        phase: 'afterWrite',
                        fn: ({ state }) => {
                            this.handlePopperUpdate(state);
                        }
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top', 'bottom', 'right', 'left'],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                        },
                    }
                ],
                ...this._args,
            };

            if (this.popperInstance) {
                this.popperInstance.destroy(); // Destroy previous instance if exists
            }

            this.popperInstance = Popper.createPopper(this._controlledby[0], this._element[0], settings);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Get Placement
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        getPlacement() {
            return this._element.data('popper-placement') || 'bottom';
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Get Offset By Placement
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        getOffsetByPlacement(placement) {
            let skidding = this._element.data('popper-skidding');
            let distance = this._element.data('popper-distance');

            const offSidePlacement = ['left-start', 'left-end', 'right-start', 'right-end'];
            const verticalPlacement = ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end'];

            skidding = skidding || offSidePlacement.includes(placement)
                ? placement.endsWith('-end') ? 10 : -10
                : ['top', 'bottom'].includes(placement)
                    ? 5
                    : (placement === 'bottom-end') ? 30 : -30;

            distance = distance || (verticalPlacement.includes(placement) ? 35 : 30);

            return { skidding, distance };
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Popper Update
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handlePopperUpdate(state) {
            if (!state) return;

            // Recalculate skidding and distance based on new placement
            let { placement } = state;

            // If placement begins w

            const { skidding, distance } = this.getOffsetByPlacement(placement);

            // Update the offset modifier
            const offsetModifier = state.orderedModifiers.find(m => m.name === 'offset');
            if (offsetModifier) {
                offsetModifier.options.offset = [skidding, distance];
            }

            // Optionally force an update if necessary
            // this.popperInstance.forceUpdate();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Open
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleOpen = () => {
            this._element
                .addClass('m-popover--open')
                .attr('tabindex', '1');

            if (this._args.focusOnPopover) {
                setTimeout(function () {
                    this._element.focus();
                }, 100);
            } else {
                const $firstFocusable = this._element;

                setTimeout(function () {
                    $firstFocusable.focus();
                }, 100);
            }

            this._element.trigger('_open', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Close
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleClose = () => {
            this._element
                .removeClass('m-popover--open')
                .attr('tabindex', '-1');

            if (this._controlledby[0]) {
                this._controlledby
                    .removeClass('m-popover-trigger--open')
                    .focus();
            }

            this._element.trigger('_close', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Blur
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleBlur = event => {
            if (event.target.tagName === 'SELECT') return;

            if (
                event.relatedTarget === null ||
                (
                    !$(event.relatedTarget).closest(".m-popover")[0] &&
                    !$(event.relatedTarget).is(".m-popover") &&
                    !$(event.relatedTarget).is(".m-popover-trigger:not(.m-popover-trigger--open)")
                )
            ) {
                this.handleClose();
            }
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Window Click
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleWindowClick = event => {
            if (!this._element.hasClass('m-popover--open')) {
                return;
            }

            if (!$(event.target).closest(this._element).length && !$(event.target).closest(this._controlledby).length && !$(event.target).is(this._controlledby)) {
                this.handleClose();
            }
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Keydown
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleKeydown = event => {
            switch (event.key) {
                case 'Tab':
                    const $firstFocusable = this._focusable[0];
                    const $lastFocusable = this._focusable[this._focusable.length - 1];

                    if (
                        ($(event.target).is($lastFocusable) && !event.shiftKey) ||
                        ($(event.target).is($firstFocusable) && event.shiftKey)
                    ) {
                        event.preventDefault();

                        if ($(event.target).is($lastFocusable)) {
                            $firstFocusable.focus();
                        } else {
                            $lastFocusable.focus();
                        }
                    } else if ($(event.target).is(".m-popover")) {
                        event.preventDefault();

                        $firstFocusable.focus();
                    }
                    break;

                case 'Escape':
                case 'Esc':
                    this.handleClose();
            }
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.popover = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i]._popover = new Popover(_[i], opt);
            else
                ret = _[i]._popover[opt].apply(_[i]._popover, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-popover').popover();

});